import * as Linking from 'expo-linking';
import React from 'react';
import Show from '../../Show/Show';
import { CREATE_USER_EVENT } from '../../../state/mutations/UserEvent';
import { CollapsableWithRedoButton } from '../../../components/Collapsable/CollapsableWithRedoButton';
import { CompanyAssistanceItem } from '../../../components/Assistance/CompanyAssistanceItem';
import { FlatList, StyleSheet, View } from 'react-native';
import { GET_REDO_SESSION } from '../../../state/queries/Session';
import { ParagraphMRegular } from '../../../config/designSystem/typography';
import { client } from '../../../config/apollo/client';
import { concatPath } from '../../../utils/links/concatPath';
import { observer } from 'mobx-react';
import { privateKey, regularSessionKey, sessionStackKey } from '../../../constants/routeKeys';
import { router, useFocusEffect } from 'expo-router';
import { useStores } from '../../../hooks/useStores';




const CompanyOwnRessources = observer(({errorMessageIfNone}: {errorMessageIfNone: boolean}) => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;
  const ownAssistanceItems = rootStore?.user?.company?.ownAssistanceItems;
  const explanationConditioning = rootStore?.user?.company?.explanationConditioning;
  const dataAvailable = !!ownAssistanceItems && ownAssistanceItems.length > 0;
  const [sessionId, setSessionId] = React.useState<string>('');



  const goToSession = (sessionId: string) => {
    router.navigate({
      pathname: concatPath([privateKey, sessionStackKey,regularSessionKey], -1) as string,
      params: {
        sessionId,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false)
      }});
  };




  React.useEffect(()=> {
    getRedoSession();
  }, []);

  const getRedoSession = async () => {
    const {data} = await client.query({ query: GET_REDO_SESSION});
    if(data && 'redoSession' in data) {
      setSessionId(data?.redoSession?._id);
    }
  };


  useFocusEffect(() => {
    rootStore?.user.fetchOwnAssistanceItems(rootStore.language.language);
  });



  const onPressTakeSession = () => {
    if(sessionId) {
      goToSession(sessionId);
    }
  };

  const renderItem =({ item, index }) => {
    let logo: any = {};
    const background = {
      fromStore: true,
      storeName: 'assistance',
      backgroundName: 'background'+index,
      uri: null,
    };
    let link = '';
    switch (item.type) {
    case 'PHONE': {
      logo = {
        type: 'Feather',
        name: 'phone-call',
        color: 'black',
        size: 30,
      };

      link = 'tel:' + item.linkInfo;
      break;
    }
    case 'EMAIL': {
      logo = {
        type: 'Feather',
        name: 'mail',
        color: 'black',
        size: 30,
      };
      link = 'mailto:' + item.linkInfo;
      break;
    }
    case 'WEBSITE': {
      logo = {
        type: 'MaterialCommunityIcons',
        name: 'web',
        color: 'black',
        size: 30,
      };
      link = item.linkInfo;
      break;
    }
    }
    const onPress = async () => {
      client.mutate({
        mutation: CREATE_USER_EVENT,
        fetchPolicy:'no-cache',
        variables: {
          input: {
            type:'AssistanceItemClicked',
            entityId:item._id
          }
        }
      });
      Linking.openURL(link);
    };
    let image;
    let colorBackground;
    if (item.image && item.image !== '') {
      image = {
        fromStore: false,
        uri: item.image,
      };
    } else {
      image = {
        fromStore: true,
        storeName: 'assistance',
        imageName: 'no_other_image',
      };
    }

    const itemProp = {
      title: item.title,
      description: item.description,
      image,
      background: background,
      colorBackground,
      logo,
      onPress,
      index
    };
    return <CompanyAssistanceItem item={itemProp} key={index}/>;
  };


  return (
    <View>

      {rootStore?.user?.company?.withRedoSession ?(<CollapsableWithRedoButton
        title={labels?.OWN?.REDO_TITLE}
        button={labels?.OWN?.REDO_BUTTON}
        content={explanationConditioning || '' as string}
        onPress={onPressTakeSession}
      />):null}
      <Show when={dataAvailable} >
        <FlatList
          data={ownAssistanceItems}
          keyExtractor={item => {
            return item._id;
          }}
          renderItem={renderItem}
          contentContainerStyle={styles.scrollContainer}
        />
      </Show>
      <Show when={!dataAvailable && errorMessageIfNone} fallback={null}>
        <ParagraphMRegular> {labels?.OWN?.NONE ? labels.OWN.NONE : 'Oops, no help available here.'}</ParagraphMRegular>
      </Show>

    </View>
  );
});

const styles = StyleSheet.create({
  scrollContainer: { paddingBottom: 60 },
});

export default CompanyOwnRessources;
